export const regexpPhone =
  /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?(?!-)[\d\- ]{7,10}$/;

export const regexpSumm = /^(?!0\d)(?:\d{1,11}(?:\.\d{1,2})?|100000000000)$/;

export const regexpInn = /^[0-9]{10,12}$/;

export const regexpLetter = /^[A-Za-zА-Яа-яЁё-]+$/;
